import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    query: {},
    profile: {},
    step: 1,
    bgcolor: '#0a5188',
    profileinfo: {}
  },
  mutations: {
  },
  actions: {
    messengerClose() {
      MessengerExtensions.requestCloseBrowser(
        function success() { },
        function error() {
          window.close();
        }
      );
    }
  },
})
